import app from 'flarum/forum/app';
import { addGameComposerAutocomplete } from './addGameComposerAutocomplete';
import { addGameMentionTooltip } from './addGameMentionTooltip';
import { addNavLinks } from './addNavLinks';

app.initializers.add('cestpasdujdr/flarum-ext-ludotheque', () => {
    addGameComposerAutocomplete();
    addGameMentionTooltip();
    addNavLinks();
});
